import React, { useEffect, useState } from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    required,
    NumberInput,
    Show,
    SelectArrayInput,
    List,
    TextField,
    NumberField,
    TopToolbar,
    CreateButton,
    FilterButton,
    ExportButton,
    Datagrid,
    EditButton,
    BooleanField,
    ReferenceField,
    SelectField,
    SearchInput,
} from 'react-admin';
import { CsvImportButton } from "../import/CsvImportButton";
import { CsvExportForImportButton } from "../import/CsvExportForImportButton";
import { nokPersonaImport } from "../import/configs/nokPersonaImport";

// A name search, as the other HQ lists have; HQ-API's `name` filter is a partial match.
const ListFilters: React.ReactElement[] = [
    <SearchInput key="name" source="name" alwaysOn />,
];

const ListActions = () => {
    return(
        <TopToolbar>
            {/* Was isAdmin, which showed this button to ROLE_ADMIN while HQ-API held the write to
                super admin and above, so an admin got a create form the POST then refused.
                HQ_Nok::faux_nokkers is the API's own tier, which closes the gap. */}
                <CreateButton />
                <CsvImportButton config={ nokPersonaImport } />
                <CsvExportForImportButton config={ nokPersonaImport } />
            {/*<FilterButton />*/}
            <ExportButton />
        </TopToolbar>
    );
}


export const NokPersonaList = () => {

    return (
        <List
            actions={<ListActions/>}
            filters={ ListFilters }
        >
            <Datagrid bulkActionButtons={false} >
                <TextField source="id" />
                <TextField source="name" />
                <ReferenceField source="nokWebsite" reference="nok_websites" />
                <EditButton />
            </Datagrid>
        </List>
    );
}
